/**
 * Created by chengpanwang on 2017/3/23.
 */
var AppConfig = {
  install (Vue, options) {
    Vue.prototype.$appConfig = AppConfig
  },

  /* eslint-disable */
  noneImg: '/assets/img/none.jpg',
  baseUrl: apiBaseUrl || 'http://localhost:7070',
  active: activeProfile || 'test',
  isQuqukid: (function () {
    try {
      return window.location.hostname.indexOf('ququkid.com') !== -1
    } catch (e) {
      return false
    }
  })()
}

export default AppConfig



// WEBPACK FOOTER //
// ./src/AppConfig.js